
import { RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { Crown } from "lucide-react";
import { MessageTone } from "@/types/message";

interface ToneOptionProps {
  tone: {
    value: MessageTone;
    label: string;
    description: string;
    isPro?: boolean;
  };
  isAccessible: boolean;
}

const ToneOption = ({ tone, isAccessible }: ToneOptionProps) => {
  return (
    <div 
      className={`flex items-start space-x-2 ${!isAccessible ? 'opacity-50' : ''}`}
    >
      <RadioGroupItem 
        value={tone.value} 
        id={`tone-${tone.value}`} 
        className="mt-1"
        // Allow selection but we'll validate on submit
      />
      <div className="grid gap-0.5 flex-1">
        <Label 
          htmlFor={`tone-${tone.value}`} 
          className="font-medium cursor-pointer flex items-center gap-2"
        >
          {tone.label}
          {tone.isPro && <Crown className="h-3 w-3 text-amber-500" />}
          {!isAccessible && <span className="text-xs text-muted-foreground">(Pro only)</span>}
        </Label>
        <p className="text-xs text-muted-foreground">
          {tone.description}
        </p>
      </div>
    </div>
  );
};

export default ToneOption;
